import styled, { css } from 'styled-components';

import Tooltip from '../../../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isField: boolean;
  isErrored: boolean;
}
interface SelectPARAMS {
  placeHolder: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #b0bec5;
  border-radius: 10px;
  padding: 10px 0;
  width: 100%;
  color: #455a64;

  & + div {
    margin-top: 8px;
  }

  ${props =>
    props.isErrored &&
    css`
      border-color: #c53030;
      color: #c53030;
    `}

  ${props =>
    props.isFocused &&
    css`
      color: #2196f3;
      //border-color: #2196f3;
    `}

  ${props =>
    props.isField &&
    css`
      color: #78909c;
    `}

  > svg {
    font-size: 30px;
    margin-right: 10px;
  }
`;

export const Select = styled.select<SelectPARAMS>`
  background: transparent;
  border: 0;
  font-weight: 500;
  color: #333;
  margin: 5px 0;
  width: 100%;

  ${props =>
    !props.placeHolder &&
    css`
      color: #90a4ae;
    `}

  :focus {
    box-shadow: 0 0 0 0;
    border: 0 none;
    outline: 0;
  }
`;

export const Option = styled.option``;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff !important;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
